module.exports = __webpack_public_path__ + "img/dance.0aee5f5c.jpg";